module.exports = __webpack_public_path__ + "static/media/dimsport.a59142de.png";